import { apiPost, authenticate } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/MAGIC_LINK_SIGN_IN";
export const SIGN_IN_WITH_MAGIC_LINK = `${NAMESPACE}/SIGN_IN`;

export const signInWithMagicLink = (token) => async (dispatch) => {
  const signInAction = apiPost(
    SIGN_IN_WITH_MAGIC_LINK,
    "auth/magic-link/sign-in",
    { token },
    { auth: false, preventErrorNotification: true }
  );

  const result = await dispatch(signInAction);

  const { success, response } = result;
  if (success && response.tokens && !response.secondFactor) {
    const { access, refresh } = response.tokens;
    dispatch(authenticate(access, refresh));
  }

  return result;
};
